import type { SettingsEntryId } from "./settings-entries";
import { settingsEntries } from "./settings-entries";

export type SettingsGuardRedirectState = {
  settingsEntryDenied: SettingsEntryId;
};

export function settingsGuardRedirectState(entryId: SettingsEntryId): SettingsGuardRedirectState {
  return { settingsEntryDenied: entryId };
}

export function settingsEntryDeniedFromLocationState(state: unknown): SettingsEntryId | null {
  if (!state || typeof state !== "object" || !("settingsEntryDenied" in state)) return null;
  const denied = (state as SettingsGuardRedirectState).settingsEntryDenied;
  if (typeof denied !== "string") return null;
  return settingsEntries.some((entry) => entry.id === denied) ? denied : null;
}
